import React, { Component } from 'react';
import axios from 'axios';
import FeatherIcon from 'feather-icons-react';
import ReactLoading from "react-loading";
import { toast } from 'react-toastify';
import { getActiveModule, getModuleConfig, getModuleUrl } from '../moduleConfig';
import LoginView from '../components/layout/LoginView';
import { checkForUpdates } from '../serviceWorkerRegistration';

class Login extends Component {
    state = {
        username: "",
        password: "",
        error : "",
        click : false
    }

    componentDidMount() {
        checkForUpdates();
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    login  = () => {
        this.setState({
            click : true,
            error : ""
        })
         axios.post('login', {
            username: this.state.username,
            password: this.state.password
        }).then((login) => {
            localStorage.setItem("user", JSON.stringify(login.data.data));
            localStorage.setItem("profiles", JSON.stringify(login.data.profiles));

            if(login.data?.profiles?.length === 1)
            {
                localStorage.setItem("profile", JSON.stringify(login.data.profiles[0]));
            }
            localStorage.setItem("establishmentId", JSON.stringify(login.data.data.staff?.establishmentId));
            localStorage.setItem("establishment", JSON.stringify(login.data.data.staff?.establishment));
            
            localStorage.setItem("yearId", login.data.data?.scolary_year)
            localStorage.setItem("permissions", login.data.permissions ? JSON.stringify(login.data.permissions) : []);
            window.location.replace(getModuleUrl(getActiveModule()))
        }).catch((error) => {
            const isNetworkError = !error.response;
            const message = isNetworkError
                ? error.message ||
                  "Connexion au serveur impossible. Aucune session hors ligne n'est disponible sur cet appareil."
                : error.response?.data?.msg || "Connexion impossible.";

            this.setState({
                error: message,
                click: false,
            });
            toast(message, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    render() {
        const moduleConfig = getModuleConfig();

        if (process.env.REACT_APP_LEGACY_LAYOUT !== "true") return (
            <LoginView
                username={this.state.username}
                password={this.state.password}
                error={this.state.error}
                loading={this.state.click && !this.state.error}
                onChange={this.handleInput}
                onSubmit={this.login}
            />
        );
        return (
            <div id="auth">
                
                        <section className="section register min-vh-50 d-flex flex-column align-items-center justify-content-center ">
                            <div className="container">
                            <div className="row justify-content-center mt-4  ">
                                <div className="col-md-5 col-sm-12 mx-auto d-flex flex-column align-items-center justify-content-center p-0">
                    

                                <div className="card mt-4 shadow overflow-hidden rounded-3 mx-4">

                                    <div className="card-body">

                                    <div className="mt-1">
                                        <img className="d-block mx-auto" src={ process.env.REACT_APP_APIEVIVESOMA +'/files/evivesoma.png'} alt="" width="100" height="80" />
                                        <h5 className="font-monospace text-center  fs-4">{ process.env.REACT_APP_NAME } {moduleConfig.label}</h5>
                                        {/* <div className="text-center small lead">Entrer votre Email et mot de passe pour vous authentifier</div> */}
                                    </div>

                                    <form className="row g-3 needs-validation">
                                        {this.state.error && (<div className="border  border-1 rounded-3 border-danger text-center text-danger py-1 px-2 text-small">{this.state.error}</div>)}
                                        <div className="col-12">
                                            <label htmlFor="yourUsername" className="form-label font-monospace">Email ou Téléphone</label>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text bg-white" id="inputGroupPrepend"><FeatherIcon icon={"lock"} size={13}></FeatherIcon> </span>
                                                <input type="text"  name="username" onChange={this.handleInput} className="form-control form-control-sm bg-white " id="yourUsername" />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <label htmlFor="yourPassword" className="form-label font-monospace">Mot de passe</label>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text bg-white" id="inputGroupPrepend"><FeatherIcon icon={"key"} size={13}></FeatherIcon> </span>
                                                <input type="password" name="password" className="form-control form-control-sm bg-white " onChange={this.handleInput} id="yourPassword" />
                                            </div>
                                        </div>
                                        
                                        <div className="col-12">
                                            <button className="btn btn-primary btn-sm w-100" type='button' onClick={() => this.login()}>
                                            <div className='d-flex justify-content-center'>
                                                {
                                                    this.state.click && (
                                                        !this.state.error && (
                                                            <ReactLoading type="spokes" color="white" height={20} width={15} />
                                                        )
                                                    )
                                                }
                                                <span>Connexion</span>
                                            </div>    
                                            </button>
                                        </div>
                                        <div className="col-12">
                                        <p className="small mb-0">Vous n'avez pas un compte? <a href="#http://evivesomarh.app"  className="text-decoration-none">Contactez le responsable</a></p>
                                        </div>
                                        <div className="col-12 text-center small">
                                            <a href="https://evivesoma.net" target="_blank" rel="noreferrer" className="text-decoration-none">EviveSoma</a>
                                            <span className="mx-1">·</span>
                                            <a href="https://evivedigital.net" target="_blank" rel="noreferrer" className="text-decoration-none">EviveDigital</a>
                                        </div>
                                    </form>

                                    </div>
                                </div>

                                </div>
                            </div>
                            </div>

                        </section>
                 
            </div>
        );
    }
}


export default Login;
